/**
 * 位移场重采样（ADR-0013）。薄封装，不关心脏矩形怎么裁——那是调用方的事：
 * 预览阶段裁"这一小块笔刷触碰区域"，提交阶段裁"整段会话的累积外接矩形"，
 * 两种裁剪策略不该塞进这一层。
 */
import { warp_field_bilinear_rgba8 } from '../../wasm/core/photosmith_core';
import { ensureKernel } from '../wasm-kernel';

export interface WarpOptions {
  readonly signal?: AbortSignal;
}

function throwIfAborted(signal: AbortSignal | undefined): void {
  if (signal?.aborted === true) throw new DOMException('操作已中止', 'AbortError');
}

/**
 * 按位移场对一块 RGBA8 区域做反向映射+双线性重采样。`dx`/`dy` 长度必须
 * 恰为 `width*height`（逐像素，与 `pixels` 同网格）。不改动传入的数组。
 */
export async function warpRegion(
  pixels: Uint8Array,
  width: number,
  height: number,
  dx: Float32Array,
  dy: Float32Array,
  options: WarpOptions = {},
): Promise<Uint8Array> {
  throwIfAborted(options.signal);
  await ensureKernel();
  throwIfAborted(options.signal);
  return warp_field_bilinear_rgba8(pixels, width, height, dx, dy);
}
